// src/components/Services/Services.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  // ✅ Services matching your orange reference image
  const services = [
    {
      id: "website-designing",
      icon: faPenNib,
      title: "Website Designing",
      desc:
        "Modern, responsive website designs tailored to your brand—built for trust, clarity, and conversions across all devices.",
    },
    {
      id: "web-development",
      icon: faLaptopCode,
      title: "Web Development",
      desc:
        "High-quality development for fast, secure websites and web apps. WordPress, HTML/CSS, and custom builds—done cleanly and scalable.",
    },
    {
      id: "search-engine-optimization",
      icon: faMagnifyingGlass,
      title: "Search Engine Optimization",
      desc:
        "We research your market, fix technical issues, and optimize your content so you rank for real buyer-intent keywords—not fluff traffic.",
    },
    {
      id: "social-media-marketing",
      icon: faShareNodes,
      title: "Social Media Marketing",
      desc:
        "Content + campaigns that grow your brand and engagement across social platforms—built to generate inquiries and leads consistently.",
    },
    {
      id: "search-engine-marketing",
      icon: faRocket,
      title: "Search Engine Marketing",
      desc:
        "Paid campaigns that bring qualified leads quickly. We optimize targeting, creatives, and landing pages for ROAS and lower CPL.",
    },
    {
      id: "local-seo",
      icon: faLocationDot,
      title: "Local SEO",
      desc:
        "Improve visibility on Google Maps and local search with on-page optimization, citations, and profile improvements to drive nearby leads.",
    },
  ];

  const open = (id) => navigate(`/services/${id}`);
  const onKey = (e, id) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      open(id);
    }
  };

  return (
    <section className="svc3" aria-label="Services">
      <div className="svc3-bg" aria-hidden="true" />
      <div className="svc3-wrap">
        <div className="svc3-grid" role="list">
          {services.map((s) => (
            <article
              key={s.id}
              role="listitem"
              className="svc3-item"
              tabIndex={0}
              onClick={() => open(s.id)}
              onKeyDown={(e) => onKey(e, s.id)}
              aria-label={`${s.title} — ${s.desc}`}
            >
              <div className="svc3-icon" aria-hidden="true">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="svc3-text">
                <h3 className="svc3-title">{s.title}</h3>
                <p className="svc3-desc">{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
